<template>
  <section ref="organization" class="tight half bb">
    <div class="big mbig bb pb" id="backstage">Backstage</div>
      <collapse
        :uid="organization.uid"
        :fold="true"
        parent="organization"
        id="organization" 
        class="alone"
      >
        <template v-slot:header>
          <div class="first">{{ organization.title }}</div>
        </template>
        <template v-slot:content>
          <div v-for="item in organization.organizers"
        :key="item.title" class="grid mobile mb">
            <div>
              <img v-if="item.image" :src="item.image.url" :alt="item.name" />
            </div>
            <div class="pr2" v-html="item.bio"></div>
          </div>
          <div class="big pt bt" v-html="contact.address"></div>
        </template>
      </collapse>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      organization: [],
      contact: []
    };
  },
  created() {
    API.organization(this.$i18n.locale).then(page => {
      this.organization = page.data.result;
    });
    API.contact(this.$i18n.locale).then(page => {
      this.contact = page.data.result;
    });
  }
};
</script>

<style></style>
